import React, { useEffect, useState } from "react";
import config from "../../../config";
import TextArea from "../../TextArea/TextArea";
import "../Modal2.css";
import Input from "../../input/input";
import axios from "../../../utils/Security/axiosInstance";
import { authFetch } from "../../../utils/Security/authFetch";
import { getSignatureLines } from "../../../utils/emailSignature";

type ConfirmModalProps = {
  data: {
    id: string;
    ticketId: string;
    user?: string;
    message?: string;
    responce?: string;
    foruser?: [];
    affectedCustomer?: string;
  };
  onConfirm: () => void;
  onCancel: () => void;
};
const username = localStorage.getItem("username") || "System";
const isAdmin = localStorage.getItem("isAdmin") === "true";

const CommunicationModal: React.FC<ConfirmModalProps> = ({
  data,
  onConfirm,
  onCancel,
}) => {
  //console.log("dataaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa", data);
  const [message, setmessage] = useState<string>(data.message || "");
  const [users, setUsers] = useState([]);

  const postMessage = async (payload: any) => {
    const res = await authFetch(`${config.apiBaseUrl}/api/communications`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      const err = await res.text();
      throw new Error(err || "Failed to post message");
    }

    return res;
  };
  useEffect(() => {
    if (!data.affectedCustomer) return;

    const fetchUsers = async () => {
      try {
        const response = await axios.get(
          `${config.apiBaseUrl}/api/users/id-by-organization?organization=${data.affectedCustomer}`
        );
        setUsers(response.data);
        //console.log("sdsdssdsdsdds", response.data);
      } catch (error) {
        console.error("Error fetching users:", error);
        setUsers([]);
      }
    };

    fetchUsers();
  }, [data.affectedCustomer]);
  const handleConfirm = async () => {
    if (!message.trim()) {
      alert("Please enter a Message note before submitting.");
      return;
    }

    const username = localStorage.getItem("username") || "System";
    //console.log("dataaaaaaaaaaaaaaaaaajackso", data);
    const payload = {
      users: `${username}`,
      message: `${message}`,
      response: ``,
      foruserid: users,
      date: new Date().toISOString(),
      ticketid: data.ticketId,
    };
    if (!isAdmin) {
      try {
        await authFetch(`${config.apiBaseUrl}/api/email/send`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            to: "g.kattan@bcomsat.com",
            subject: `${data.affectedCustomer} Sent you a message ${data.ticketId} .`,
            body: `
    <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
      <p>Hello,</p>

      <p>This Ticket was Opened with following comment:</p>

      <p><strong>Customer:</strong> ${data.affectedCustomer}<br>
\

      <p>Regards,<br><br></p>

      <div style="padding: 12px; border-left: 4px solid #ffa500; background-color: #f9f9f9; color: #555; font-size: 13px;">
        <strong>Managed Services Operations</strong><br>
        ${getSignatureLines(data.affectedCustomer, "#555")}
      </div>
    </div>
  `,
          }),
        });

        //console.log("Email sent successfully!");
      } catch (emailErr) {
        console.error("Failed to send email notification:", emailErr);
      }
    }
    try {
      await postMessage(payload);
      alert("Message Sent Successfully!");
      onConfirm();
    } catch (error) {
      alert(`Failed to Send Message: ${(error as Error).message}`);
    }
  };

  return (
    <div
      className="modal-overlay"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        padding: "1rem",
      }}
    >
      <div
        className="modal-content"
        style={{
          backgroundColor: "#fff",
          padding: "2rem 2.5rem",
          borderRadius: "12px",
          maxWidth: 450,
          width: "100%",
          boxShadow:
            "0 8px 24px rgba(0, 0, 0, 0.15), 0 2px 8px rgba(0, 0, 0, 0.1)",
          display: "flex",
          flexDirection: "column",
          gap: "1.5rem",
          fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        }}
      >
        {isAdmin && <h4>Communicate with {data.affectedCustomer}</h4>}
        {username}
        <TextArea
          label="Message"
          onChange={setmessage}
          style={{ width: "100%" }}
          value={""}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "1rem",
            marginTop: "1rem",
          }}
        >
          <button
            onClick={() => {
              //console.log("Journal modal closed by user.");
              onCancel();
            }}
            style={{
              padding: "0.5rem 1.2rem",
              borderRadius: "6px",
              border: "1px solid #ccc",
              backgroundColor: "#fff",
              color: "#444",
              cursor: "pointer",
              fontWeight: 500,
              transition: "background-color 0.2s ease",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#f0f0f0")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "#fff")
            }
          >
            Cancel
          </button>

          <button
            onClick={handleConfirm}
            style={{
              padding: "0.5rem 1.5rem",
              borderRadius: "6px",
              border: "none",
              backgroundColor: "#f97316",
              color: "white",
              cursor: "pointer",
              fontWeight: 600,
              boxShadow: "0 4px 8px rgba(249, 115, 22, 0.4)",
              transition: "background-color 0.2s ease",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#c4510b")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "#f97316")
            }
          >
            Send Message
          </button>
        </div>
      </div>
    </div>
  );
};

export default CommunicationModal;
